import { brighten, getValue } from "../utils.js";

export const CALENDAR = {
  "Calendar.Bg.Color": {
    ref: "Popover.Bg.Color"
  },
  "Calendar.Border.Top.Left.Radius": {
    ref: "Input.Border.Top.Left.Radius"
  },
  "Calendar.Border.Top.Right.Radius": {
    ref: "Input.Border.Top.Right.Radius"
  },
  "Calendar.Border.Bottom.Left.Radius": {
    ref: "Input.Border.Bottom.Left.Radius"
  },
  "Calendar.Border.Bottom.Right.Radius": {
    ref: "Input.Border.Bottom.Right.Radius"
  },
  "Calendar.Border.Color": {
    ref: "Popover.Border.Color"
  },
  "Calendar.Border.Left.Width": {
    ref: "Popover.Border.Left.Width"
  },
  "Calendar.Border.Right.Width": {
    ref: "Popover.Border.Right.Width"
  },
  "Calendar.Border.Top.Width": {
    ref: "Popover.Border.Top.Width"
  },
  "Calendar.Border.Bottom.Width": {
    ref: "Popover.Border.Bottom.Width"
  },
  "Calender.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Calendar.Color": {
    ref: "Input.Color"
  },
  "Calendar.Icon.Color": {
    ref: "Color.Icon.Dark.Gray"
  },
  "Calendar.Shadow": {
    ref: "Popover.Shadow"
  },
  "Calender.Today.Color": {
    ref: "Color.Primary.500"
  },
  "Calender.Today.Bg.Color": {
    ref: "Color.White"
  },
  "Calender.Today.Border.Color": {
    ref: "Color.Primary.500"
  },
  "Calender.Selected.Color": {
    ref: "Color.White"
  },
  "Calender.Selected.Bg.Color": {
    ref: "Color.Primary.500"
  },
  "Calender.Selected.Border.Color": {
    defaultValue: "transparent"
  },
  "Calender.Hover.Bg.Color": {
    ref: "Popover.Bg.Color"
  },
  "Calender.Hover.Border.Color": {
    ref: "Color.Gray.500"
  },
  "Calender.Range.Bg.Color": {
    valueFunc: (meta) => {
      return brighten(getValue("Color.Primary.500", meta), 0.5);
    }
  }
};
